<mat-dialog-content>
  
  <div class="dialog-width">
    @if(data.type === 'ONE_TIME' && !paying()) {
      Click to pay with your Paypal account
    }
    @if(data.type === 'ONGOING' && !paying()) {
      Click to subscribe with your Paypal account
    }
    @if(paying()) {
      {{data.type === 'ONE_TIME' ? 'Paying...': 'Subscribing...'}}
    }
  </div>

  <div class="row justify-content-center my-4">
    <div class="col-md-10">
      @if(loading()) {
        <div class="loading-section">
          <mat-spinner></mat-spinner>
        </div>
      }
      <div id="paypalButtonsVault" [ngClass]="{hide: loading() || paying()}"></div>
      <button mat-raised-button class="cancel-btn" [mat-dialog-close]="false" [disabled]="paying()">Cancel</button>
    </div>
  </div>

</mat-dialog-content>